import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import {
  alpha,
  Button,
  Grid,
  styled,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useRouter } from "../../helper-functions/useRouterReplacement";
import React from "react";
import {
  CustomBoxFullWidth,
  CustomStackFullWidth,
} from "../../styled-components/CustomStyles.style";
import { useIsSmallScreen } from "../../utils/CommonValues";
import CustomContainer from "../container";
import DollarSignHighlighter from "../DollarSignHighlighter";
import DeliveryImage from "./svg-components/deliveryImage";

export const CustomButton = styled(Button)(({ theme, boxshadow }) => ({
  background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark || theme.palette.primary.main} 100%)`,
  height: "50px",
  borderRadius: "50px",
  boxShadow: theme.palette.mode === 'dark' 
    ? `0px 10px 20px ${alpha(theme.palette.primary.main, 0.3)}`
    : "0px 10px 20px rgba(13, 148, 136, 0.2)",
  color: theme.palette.whiteContainer.main,
  padding: "0 30px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  transition: "all 0.3s ease-in-out",
  "&:hover": {
    background: `linear-gradient(135deg, ${theme.palette.primary.light || theme.palette.primary.main} 0%, ${theme.palette.primary.main} 100%)`,
    transform: "translateY(-2px)",
    boxShadow: theme.palette.mode === 'dark'
      ? `0px 15px 30px ${alpha(theme.palette.primary.main, 0.4)}`
      : "0px 15px 30px rgba(13, 148, 136, 0.3)",
  },
  [theme.breakpoints.down("sm")]: {
    height: "40px",
    marginTop: "-2px",
  },
}));
const ComponentOne = ({ landingPageData, configData, handleOrderNow }) => {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("sm"));
  const isSmallScreen = useIsSmallScreen();
  const router = useRouter();
  const handleButtonClick = () => {
    router.push(landingPageData?.company_button_url);
  };
  return (
    <>
      <CustomContainer>
        <CustomBoxFullWidth
          sx={{
            position: "relative",
            marginTop: "4rem",
            marginBottom: "2rem",
          }}
        >
          <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            spacing={{ xs: 1, md: 4 }}
            flexDirection={{ xs: "column-reverse", md: "row" }}
          >
            <Grid item xs={12} sm={12} md={6}>
              <CustomStackFullWidth
                spacing={isSmall ? 2 : 3}
                paddingBottom={{ xs: "1rem", sm: "2rem", md: "0px" }}
                sx={{
                  animation: "fadeInLeft 1s ease-out",
                  "@keyframes fadeInLeft": {
                    "0%": { opacity: 0, transform: "translateX(-20px)" },
                    "100%": { opacity: 1, transform: "translateX(0)" },
                  },
                }}
              >
                <CustomStackFullWidth>
                  <Typography
                    variant={isSmall ? "h5" : "h3"}
                    sx={{ fontWeight: 800, color: "primary.main" }}
                  >
                    <DollarSignHighlighter
                      theme={theme}
                      text={landingPageData?.company_title}
                    />
                  </Typography>
                  <Typography variant={isSmall ? "h6" : "h4"} sx={{ fontWeight: 600, mt: 1 }}>
                    <DollarSignHighlighter
                      theme={theme}
                      text={landingPageData?.company_sub_title}
                    />
                  </Typography>
                </CustomStackFullWidth>
                <Typography
                  fontSize={{ xs: "14px", md: "18px" }}
                  fontWeight="400"
                  lineHeight="1.8"
                  sx={{
                    color: (theme) => alpha(theme.palette.neutral[600], 0.9),
                  }}
                >
                  <DollarSignHighlighter
                    theme={theme}
                    text={landingPageData?.company_description}
                  />
                </Typography>
                {landingPageData?.company_button_name && (
                  <CustomStackFullWidth
                    alignItems="flex-start"
                    justifyContent="flex-start"
                    mt={2}
                  >
                    <CustomButton onClick={handleOrderNow}>
                      <Typography
                        variant={isSmallScreen ? "body2" : "body1"}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "10px",
                          fontWeight: 700
                        }}
                      >
                        {" "}
                        {landingPageData?.company_button_name}
                        {/*<DollarSignHighlighter theme={theme} text={landingPageData?.company_button_name} />*/}
                        <ArrowRightAltIcon />
                      </Typography>
                    </CustomButton>
                  </CustomStackFullWidth>
                )}
              </CustomStackFullWidth>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              align="right"
            // sx={{
            // 	"&:hover": {
            // 		"img, svg": {
            // 			transform: "scale(1.1)",
            // 		},
            // 	},
            // }}
            >
              <DeliveryImage />
            </Grid>
          </Grid>
        </CustomBoxFullWidth>
      </CustomContainer>
    </>
  );
};

ComponentOne.propTypes = {};

export default ComponentOne;

// height="550px"
// width="550px"
